import { Outlet } from 'react-router-dom';
import { SiteChrome } from './SiteChrome';
import { CartConfirmationProvider } from '../cart/CartConfirmation';

export function PublicLayout(): JSX.Element {
  return (
    <CartConfirmationProvider>
      <SiteChrome>
        <Outlet />
      </SiteChrome>
    </CartConfirmationProvider>
  );
}
